import React from 'react';
import { useTheme } from '@mui/material';
import { StyledSvg } from './StyledSvg';

const PageCableDisconnected: React.FC<
	Omit<React.ComponentProps<typeof StyledSvg>, 'children'>
> = ({ ...props }) => {
	const theme = useTheme();

	const strokeColor = theme.palette.primary.main;
	const fill1 = theme.palette.secondary.light;
	const fill2 = theme.palette.primary.light;

	return (
		<StyledSvg viewBox="0 0 300 300" {...props}>
			<g clipPath="url(#clip0_5645_1798)">
				<path
					d="M1.21094 250.158C80.1581 212.658 93.2617 97.0512 39.3686 121.211C1.21094 138.316 34.7634 183.053 98.5791 183.053"
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<rect
					x="147.386"
					y="153.383"
					width="26.4531"
					height="6.1272"
					rx="3.0636"
					transform="rotate(-16.9006 147.386 153.383)"
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<rect
					x="152.311"
					y="167.763"
					width="26.4531"
					height="6.1272"
					rx="3.0636"
					transform="rotate(-16.9006 152.311 167.763)"
					fill="white"
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M120.903 180.193C123.139 186.421 119.902 193.283 113.674 195.519C107.446 197.755 100.585 194.518 98.3487 188.29L94.6639 178.027C92.4279 171.798 95.6642 164.937 101.892 162.701C108.12 160.465 114.982 163.701 117.218 169.929L120.903 180.193Z"
					fill={fill1}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<ellipse
					cx="118.63"
					cy="175.405"
					rx="15.5132"
					ry="23.5198"
					transform="rotate(-16.1136 118.63 175.405)"
					fill={fill1}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<ellipse
					cx="124.951"
					cy="173.579"
					rx="15.5132"
					ry="23.5198"
					transform="rotate(-16.1136 124.951 173.579)"
					fill={fill1}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<ellipse
					cx="175.523"
					cy="155.345"
					rx="15.5132"
					ry="23.5198"
					transform="rotate(-16.1136 175.523 155.345)"
					fill={fill1}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<ellipse
					cx="182.363"
					cy="152.866"
					rx="15.5132"
					ry="23.5198"
					transform="rotate(-16.1136 182.363 152.866)"
					fill={fill1}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<ellipse
					cx="123.71"
					cy="164.436"
					rx="3.04297"
					ry="4.52295"
					transform="rotate(-16.1136 123.71 164.436)"
					fill={fill2}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M202.688 151.909C204.924 158.137 201.687 164.999 195.459 167.235C189.231 169.471 182.37 166.234 180.134 160.006L176.449 149.743C174.213 143.515 177.449 136.653 183.677 134.417C189.905 132.181 196.767 135.417 199.003 141.645L202.688 151.909Z"
					fill={fill1}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<ellipse
					cx="128.777"
					cy="181.975"
					rx="3.04297"
					ry="4.52295"
					transform="rotate(-16.1136 128.777 181.975)"
					fill={fill2}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M294.632 77.1318C212.395 97.5264 198.908 215.29 253.184 192.263C307.461 169.237 255.158 120.882 193.316 149.5"
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M153.631 94.1106L139.181 111.593L155.45 116.063L141.035 133.527"
					stroke={strokeColor}
					strokeWidth="4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M137.47 213.961L128.847 234.938L145.71 234.39L137.114 255.339"
					stroke={strokeColor}
					strokeWidth="4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M200.261 194.085L207.928 206.371L213.925 197.422L221.587 209.683"
					stroke={strokeColor}
					strokeWidth="4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M94.7676 129.574L101.063 139.663L105.988 132.314L112.28 142.383"
					stroke={strokeColor}
					strokeWidth="4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M154.647 190.155L153.294 201.97L161.723 199.284L160.38 211.081"
					stroke={strokeColor}
					strokeWidth="4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M96.3718 210.566L87.0155 217.906L94.8503 222.015L85.5137 229.35"
					stroke={strokeColor}
					strokeWidth="4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<rect
					x="1.21094"
					y="22.988"
					width="294.079"
					height="247.368"
					rx="24"
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M1.86816 54.1052H293.974"
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M43.515 39.5001C43.529 40.1827 43.4066 40.8612 43.155 41.4958C42.9035 42.1305 42.5278 42.7086 42.05 43.1963C41.5722 43.6839 41.0019 44.0714 40.3725 44.3358C39.7431 44.6003 39.0672 44.7366 38.3845 44.7366C37.7018 44.7366 37.0259 44.6003 36.3965 44.3358C35.7671 44.0714 35.1968 43.6839 34.719 43.1963C34.2412 42.7086 33.8656 42.1305 33.614 41.4958C33.3624 40.8612 33.24 40.1827 33.254 39.5001C33.2814 38.1576 33.834 36.8793 34.7932 35.9395C35.7524 34.9997 37.0417 34.4734 38.3845 34.4734C39.7273 34.4734 41.0167 34.9997 41.9758 35.9395C42.935 36.8793 43.4876 38.1576 43.515 39.5001Z"
					fill={fill2}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M28.2534 39.5002C28.2534 40.8612 27.7128 42.1665 26.7504 43.1288C25.788 44.0912 24.4828 44.6318 23.1218 44.6318C21.7608 44.6318 20.4556 44.0912 19.4932 43.1288C18.5309 42.1665 17.9902 40.8612 17.9902 39.5002C17.9902 38.1393 18.5309 36.834 19.4932 35.8717C20.4556 34.9093 21.7608 34.3687 23.1218 34.3687C24.4828 34.3687 25.788 34.9093 26.7504 35.8717C27.7128 36.834 28.2534 38.1393 28.2534 39.5002Z"
					fill={fill1}
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M59.2446 39.5002C59.2446 40.5152 58.9437 41.5073 58.3798 42.3512C57.8159 43.1951 57.0145 43.8528 56.0768 44.2412C55.1391 44.6296 54.1073 44.7312 53.1119 44.5332C52.1165 44.3352 51.2021 43.8465 50.4845 43.1288C49.7668 42.4111 49.2781 41.4968 49.08 40.5014C48.882 39.5059 48.9837 38.4741 49.3721 37.5365C49.7605 36.5988 50.4182 35.7973 51.2621 35.2335C52.106 34.6696 53.0981 34.3687 54.113 34.3687C55.473 34.372 56.7762 34.9138 57.7379 35.8754C58.6995 36.837 59.2412 38.1403 59.2446 39.5002Z"
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5645_1798">
					<rect width="300" height="300" fill="white" />
				</clipPath>
			</defs>
		</StyledSvg>
	);
};

export default PageCableDisconnected;
